// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QxVyJ","buttons":"styles_buttons__1Zk7T"};